import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclNavbarSecondaryService } from "certain-common-library";

@Component({
    selector: "app-setting-page",
    templateUrl: "./setting-page.view.html",
    styleUrls: []
})
export class SettingPageView implements AfterViewInit, OnInit {
    constructor(private navSecondaryService: CclNavbarSecondaryService) {
        this.navSecondaryService.sectionLabel = "Define Layout";
    }

    ngAfterViewInit(): void {}

    ngOnInit() {
        this.navSecondaryService.sectionLabel = "Define Layout";
    }
}
